import React from "react";
import DashboardOverview from "../components/dashboard/DashboardOverviewOld";
import DashboardPageContainer from "../components/dashboard/DashboardPageContainer";

const DashboardPage = () => {
	return <div><DashboardPageContainer /></div>;
};	

export default DashboardPage